<template>
  <table>
    <tr>
      <td>
        <p>{{ ft(featureName, 'received.caseLabel', $t) }}</p>
      </td>
      <td>
        <h5 class="followupData">
          <b>{{ caseName }}</b>
        </h5>
      </td>
    </tr>
    <tr>
      <td>
        <p>{{ ft(featureName, 'received.passwordLabel', $t) }}</p>
      </td>
      <td>
        <h5 class="followupData">
          <b>{{ password }}</b>
        </h5>
      </td>
    </tr>
    <tr>
      <td>
        <p>{{ ft(featureName, 'received.linkLabel', $t) }}</p>
      </td>
      <td>
        <h5 class="followupData">
          <a :href="followupUrl" target="_blank">
            <b>{{ followupUrl }}</b>
          </a>
        </h5>
      </td>
    </tr>
  </table>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'FollowupCaseDetails',
  extends: LocalizableComponent,
  props: {
    caseName: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    followupUrl: {
      type: String,
      required: true
    },
    featureName: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.followupData {
  margin-left: 20px;
  margin-bottom: 10px;
}
</style>
